import { render, staticRenderFns } from "./CaseEvidence.vue?vue&type=template&id=3939485a"
import script from "./CaseEvidence.vue?vue&type=script&lang=js"
export * from "./CaseEvidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports